import React from 'react';
import { Box, Typography } from '@mui/material';

const NoteIcon = (props: any) => (
  <svg width={props.fontSize || 64} height={props.fontSize || 64} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);

export const NoteEmptyState: React.FC = () => (
  <Box sx={{ flexGrow: 1, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.3 }}>
    <NoteIcon sx={{ fontSize: 64, mb: 2 }} />
    <Typography variant="h5">Select or create a note</Typography>
  </Box>
);

export default NoteEmptyState;
